import {
	BenefitsListBlockData,
	ExpandedBenefitsListBlock,
} from '../../types/optimizely/blocks/benefitsListBlock';
import { useFetch } from '../../hooks/useFetch';

export const useBenefitsListBlockData = (
	blockId: string,
): BenefitsListBlockData | null => {
	const { data } = useFetch<ExpandedBenefitsListBlock>(blockId);

	if (data) {
		return {
			title: data?.title?.value,
			backgroundColor: data?.backgroundColor?.value ?? 'bg-primary-violet',
			fontColor: data?.fontColor?.value ?? 'text-white',
			titleContent: data.textEditor.value,
			benefits:
				data.benefits?.expandedValue?.map((benefit) => ({
					name: benefit.name,
					imageUrl: benefit.image.value?.url,
					text: benefit.text.value,
					id: benefit.contentLink.id,
				})) ?? [],
		};
	}

	return null;
};
